import { createContext, useContext, useState, useCallback } from "react";

const ReportingYearContext = createContext(null);

export const ReportingYearProvider = ({ children }) => {
  const [reportingYear, setReportingYear] = useState(null);
  const [reportingYearId, setReportingYearId] = useState(null); // ✅ ADD THIS
  const [latestYear, setLatestYear] = useState(null);

  // ✅ Derived on every render — no setState needed, always accurate
  const isCurrentYear = Boolean(
    reportingYear && latestYear && reportingYear.trim() === latestYear.trim()
  );

  // Keep these for any page that uses them — no breaking changes
  const initYears = useCallback((selectedVal, latestVal, id) => {
    setLatestYear(latestVal);
    setReportingYearId(id); // ✅ ADD
    setReportingYear(selectedVal);
  }, []);

  const changeYear = useCallback((selectedVal, latestVal, id) => {
    setReportingYear(selectedVal);
    setLatestYear(latestVal);
    setReportingYearId(id); // ✅ ADD
  }, []);

  return (
    <ReportingYearContext.Provider
      value={{
        reportingYear,
        setReportingYear,
        latestYear,
        setLatestYear,
        isCurrentYear, // ← now always correct, no manual setter needed
        initYears,
        changeYear,
        reportingYearId, // ✅ ADD
        setReportingYearId, // ✅ ADD
      }}
    >
      {children}
    </ReportingYearContext.Provider>
  );
};

export const useReportingYear = () => {
  const ctx = useContext(ReportingYearContext);
  if (!ctx)
    throw new Error(
      "useReportingYear must be used inside ReportingYearProvider"
    );
  return ctx;
};
